export default __webpack_public_path__ + "static/media/Parents.c6bbbd3d.png";